import React, { memo } from 'react';
import { Button} from '@mui/material';
import { Variant } from '../types';
import './styles.scss';

export interface ButtonComponentProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  id: string;
  label?: string;
  icon?: React.ReactNode;
  href?: string;
  download?: any;
  disabled?: boolean;
  customStyles?: any;
  variant?: Variant;
}

export const IconButton: React.FC<ButtonComponentProps> = ({
  onClick,
  id,
  label,
  icon,
  href,
  download,
  disabled = false,
  variant = 'outlined',
  customStyles,
  ...otherProps
}: ButtonComponentProps) => {
  return (
      <Button
        className="icon_btn"
        onClick={onClick}
        id={id}
        href={href}
        color="primary"
        disabled={disabled}
        {...otherProps}
        startIcon={icon}
        variant={variant}
      >
        {label}
      </Button>
  );
};

export default memo(IconButton);
